import { render, staticRenderFns } from "./lookup_table_list.vue?vue&type=template&id=8d1c76c2&scoped=true"
import script from "./lookup_table_list.vue?vue&type=script&lang=js"
export * from "./lookup_table_list.vue?vue&type=script&lang=js"
import style0 from "./lookup_table_list.vue?vue&type=style&index=0&id=8d1c76c2&prod&scoped=true&lang=css"
import style1 from "./lookup_table_list.vue?vue&type=style&index=1&id=8d1c76c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c76c2",
  null
  
)

export default component.exports